import { CloseButton } from './CloseButton';
import {
	Drawer,
	Grid,
	type Theme,
	Typography,
	makeStyles,
} from '@material-ui/core';
import React from 'react';

interface DrawerRightProps {
	children: React.ReactChild;
	open: boolean;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	onClose: Function | any;
	title: string;
}

const useStyles = makeStyles((theme: Theme) => ({
	drawer: {
		'& .MuiDrawer-paperAnchorRight': {
			padding: '24px 16px',
			width: '25%',
			[theme.breakpoints.down('sm')]: {
				width: '90%',
			},
		},
	},
	header: {
		marginBottom: 30,
	},
	title: {
		fontWeight: 600,
	},
}));

export const DrawerRight = ({
	children,
	onClose,
	open,
	title,
}: DrawerRightProps) => {
	const classes = useStyles();

	return (
		<Drawer
			anchor={'right'}
			className={classes.drawer}
			onClose={onClose}
			open={open}
		>
			<Grid
				alignItems={'center'}
				className={classes.header}
				container
				justify={'space-between'}
			>
				<Typography className={classes.title} variant={'subtitle1'}>
					{' '}
					{title}{' '}
				</Typography>

				<CloseButton
					data-testid={'close-drawer-button'}
					onClick={onClose}
				/>
			</Grid>

			{children}
		</Drawer>
	);
};
